import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
const hosts = ['api.xxmac.win', 'api.xxmac.win', 'api.xxmac.win']
axios.interceptors.request.use(async config => {
  let url
  try { url = new URL(config.url, config.baseURL || window.location.origin) } catch (_) { return config }
  const ownApi = hosts.includes(url.hostname)
  const ownFunction = url.hostname.endsWith('-xxmac-co.cloudfunctions.net')
  if ((ownApi || ownFunction) && firebase.auth().currentUser) {
    config.headers = config.headers || {}
    const token = await firebase.auth().currentUser.getIdToken()
    if (url.pathname.startsWith('/authentication/2fa/')) config.headers['x-firebase-token'] = token
    else config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
